import React from 'react'
import { Link } from 'gatsby'
import { dasherize } from '@/utilities'
import { PeopleIcon } from '@primer/octicons-react'

const PoliticalInfo = ({
  militanciamilitantedepartidooindependiente,
  partidopoliticosicorresponde,
  lista,
  movimientoagrupacion,
  pueblooriginariosicorresponde,
}) => {
  return (
    <div>
      <p className="pb-0 mb-2 leading-none">
        <PeopleIcon verticalAlign="middle" className="mr-1" />
        Lista{' '}
        <Link to={`/listas/${dasherize(lista)}/`} className="underline">
          <strong>{lista}</strong>
        </Link>
      </p>
      {pueblooriginariosicorresponde && (
        <p className="pb-0 mb-2 leading-none">
          De origen <strong>{pueblooriginariosicorresponde}</strong>
        </p>
      )}

      {movimientoagrupacion && (
        <p className="pb-0 mb-2 leading-none">
          <PeopleIcon verticalAlign="middle" className="mr-1" />
          Agrupación o movimiento <strong>{movimientoagrupacion}</strong>
        </p>
      )}
      <p className="pb-0 mb-2 leading-tight">
        {militanciamilitantedepartidooindependiente === 'Independiente' && (
          <>
            Candidatura <strong>Independiente</strong>
          </>
        )}
        {militanciamilitantedepartidooindependiente ===
          'Militante de Partido' && (
          <>
            Militante en <strong>{partidopoliticosicorresponde}</strong>
          </>
        )}
      </p>
      <p className="pb-0 mb-2 leading-tight">
        {militanciamilitantedepartidooindependiente === 'Independiente' &&
          partidopoliticosicorresponde &&
          partidopoliticosicorresponde !== 'Independiente' && (
            <>
              Postula en el cupo de{' '}
              <strong>
                {partidopoliticosicorresponde
                  .replace('Independiente -', '')
                  .trim()}
              </strong>
            </>
          )}
      </p>
    </div>
  )
}

export default PoliticalInfo
